import { FormElementModel } from "../../../models/FormElementModel";
import {
  emailValidator,
  lengthValidator,
  passValidator,
  PERSON_NAME_MAX_LENGTH,
  repeatPassValidator,
} from "../../../../utils/formsValidation";
import { t } from "i18next";


export const userRegisterForm = (watch: any, register: any): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: t("imie"),
    isLabel: true,
    inputMaxLength: PERSON_NAME_MAX_LENGTH,
    register: { ...register("firstName", { ...lengthValidator(true, 3, PERSON_NAME_MAX_LENGTH) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    inputMaxLength: PERSON_NAME_MAX_LENGTH,
    register: { ...register("lastName", { ...lengthValidator(true, 3, PERSON_NAME_MAX_LENGTH) }) },
  },
  {
    name: "password",
    type: "password",
    text: t("haslo"),
    isLabel: true,
    register: { ...register("password", { ...passValidator(true) }) },
  },
  {
    name: "repeatPassword",
    type: "password",
    text: t("powtorz_haslo"),
    isLabel: true,
    register: { ...register("repeatPassword", { ...repeatPassValidator(true, watch("password", "")) }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
];
